import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";

const BIooPaySequentialSpinner = () => {
  const [visiblePart, setVisiblePart] = useState(0); // 0: B, 1: I, 2: oo, 3: Pay

  useEffect(() => {
    const timer = setInterval(() => {
      setVisiblePart((prev) => (prev < 3 ? prev + 1 : 0));
    }, 500); // Change every 0.5 seconds

    return () => clearInterval(timer);
  }, []);

  return (
    <Container>
      <Text>
        {visiblePart >= 0 && <B blink={visiblePart === 0}>B</B>}
        {visiblePart >= 1 && <I blink={visiblePart === 1}>I</I>}
        {visiblePart >= 2 && <O blink={visiblePart === 2}>oo</O>}
        {visiblePart >= 3 && <Pay blink={visiblePart === 3}>Pay</Pay>}
      </Text>
    </Container>
  );
};

// Animations
const blink = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
`;

// Styled Components
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #0f172a;
`;

const Text = styled.div`
  font-family: "Rajdhani", sans-serif;
  font-weight: 700;
  font-size: 2rem;
  display: flex;
  gap: 0.5rem;
`;

const Letter = styled.span`
  color: ${(props) => props.color};
  animation: ${(props) => (props.blink ? blink : "none")} 1s infinite;
`;

const B = styled(Letter).attrs({ color: "#00c6fb" })``;
const I = styled(Letter).attrs({ color: "#4facfe" })``;
const O = styled(Letter).attrs({ color: "#ff4b1f" })``;
const Pay = styled(Letter).attrs({ color: "#ff9068" })``;

export default BIooPaySequentialSpinner;
